import React from 'react'
import './styles.css';
import NavBar from './NavBar';

const TermsOfService = () => {
  return (
    <>
      {NavBar()}
      <div className="faq-wrapper">
        <h1 className="faq-title">Terms of Service</h1>
        <div className="privacy-policy-text" style={{ whiteSpace: 'pre-wrap' }}>
{`
Effective Date: July 17, 2025

Welcome to Pool Party, a mobile social application operated by Console.log LLC ("we", "us", "our"). These Terms of Service ("Terms") govern your access to and use of the Pool Party app and related services ("Service").

By accessing or using Pool Party, you agree to be bound by these Terms.

1. ELIGIBILITY
-----------------

You must be at least 18 years old to use Pool Party. By using the app, you represent and warrant that:
- You are at least 18 years old
- You have the legal capacity to enter into a binding agreement
- You are not prohibited from using the Service under applicable law

2. ACCOUNT REGISTRATION
------------------------

To use certain features, you may need to create an account by providing accurate and complete information. You are responsible for:
- Maintaining the confidentiality of your credentials
- All activities that occur under your account
- Updating your information to keep it current

3. ACCEPTABLE USE
------------------

You agree to use Pool Party in accordance with the law and these Terms. You agree **not to**:
- Harass, threaten, stalk, or harm other users
- Share explicit, abusive, or offensive content
- Record or distribute conversations without consent
- Use the Service for commercial solicitation
- Impersonate another person or entity
- Access the app using automated means or bots

We reserve the right to investigate and remove any content or account that violates these terms.

4. FEATURES & INTERACTIONS
---------------------------

Pool Party allows users to:
- Join a “pool” of local users
- Splash others to show interest
- Connect via video chat
- Match and message if both users agree

You are responsible for your interactions with other users. We do not conduct background checks or verify user identity. Exercise caution and report inappropriate behavior.

5. PAID SERVICES
-----------------

Some features (e.g., Boosts, Supersplashes) may be offered for purchase. All purchases are final and non-refundable except as required by law or platform policy (Apple/Google Play).

Subscriptions may automatically renew unless canceled through your app store account.

6. TERMINATION
---------------

We may suspend or terminate your access to the Service for violating these Terms, engaging in harmful behavior, or for any other reason at our discretion. You may also delete your account at any time.

7. INTELLECTUAL PROPERTY
--------------------------

All content, trademarks, and software associated with Pool Party are the property of Console.log LLC or its licensors. You may not copy, modify, distribute, or create derivative works without written consent.

8. DISCLAIMERS
----------------

The Service is provided “as is” and “as available” without warranties of any kind, either express or implied. We do not guarantee:
- A match or successful relationship
- Uninterrupted or error-free access
- User behavior or safety

You use Pool Party at your own risk.

9. LIMITATION OF LIABILITY
----------------------------

To the maximum extent permitted by law, Console.log LLC shall not be liable for any indirect, incidental, special, or consequential damages resulting from:
- Your use or inability to use the Service
- Interactions with other users
- Unauthorized access to your account

10. GOVERNING LAW
--------------------

These Terms are governed by and construed in accordance with the laws of the State of Illinois, USA. Any disputes shall be resolved exclusively in the state or federal courts located in Cook County, IL.

11. MODIFICATIONS
-------------------

We reserve the right to update or modify these Terms at any time. Continued use of the Service after changes constitutes acceptance.

12. CONTACT
------------

For questions or support, contact us at:

**Console.log LLC**  
Email: consolelog@consolelogllc.com  
`}
        </div>
      </div>
    </>
  )
}

export default TermsOfService;
